module.exports = __webpack_public_path__ + "img/head.a36e2bf6.png";